import mdcIcon from './mdc-icon.vue'
export const mdcIconComponents = {
  mdcIcon,
}